import { render, staticRenderFns } from "./SDSCenter.vue?vue&type=template&id=1afba54a"
import script from "./SDSCenter.vue?vue&type=script&lang=js"
export * from "./SDSCenter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports